import React from 'react';
import { createRoot } from "react-dom/client";

import 'semantic-ui-css/semantic.min.css';
import './css/custom.css'
import './css/typewriter_effect.css'
import './css/search_and_filter.css'
import './css/single_offer.css'
import  './css/job_post.css'
import './css/job_delete.css'
import './css/about_contact.css'
import './css/tos.css'

import { BrowserRouter, Routes, Route } from "react-router-dom";


import Layout from "./components/layout";

import useCheckMobileScreen from "./hooks/checkMobileScreen";

import About from "./pages/about";
import OfferPage from "./pages/offers";
import NoPage from "./pages/no_page"
import JopPost from "./pages/job_post"
import SingleOffer from "./pages/single_offer";
import JobDelete from "./pages/job_delete";
import Contact from "./pages/contact";
import Tos from './pages/tos'


const App = () => {
    let is_mobile = useCheckMobileScreen()

  return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<OfferPage is_mobile={is_mobile}/>}/>
          <Route path="about" element={<Layout is_mobile={is_mobile}> <About/> </Layout>}/>
          <Route path="job-post" element={<Layout is_mobile={is_mobile}> <JopPost is_mobile={is_mobile}/> </Layout>}/>
          <Route path="contact" element={<Layout is_mobile={is_mobile}> <Contact is_mobile={is_mobile}/> </Layout>}></Route>
          <Route path="tos" element={<Layout is_mobile={is_mobile}> <Tos is_mobile={is_mobile}/> </Layout>}></Route>
          <Route path="offer/:offer_id/:offer_title"
                 element={<Layout is_mobile={is_mobile}> <SingleOffer is_mobile={is_mobile}/> </Layout>}/>
          <Route path="job-delete/:uuid" element={<Layout is_mobile={is_mobile}> <JobDelete is_mobile={is_mobile}/> </Layout>} />
          <Route path="*" element={<Layout is_mobile={is_mobile}> <NoPage/> </Layout>}/>
        </Routes>
      </BrowserRouter>
  );
}

createRoot(document.querySelector('.container')).render(<App />);
